module.exports = __webpack_public_path__ + "img/warning-time.78013219.png";